export default __webpack_public_path__ + "static/media/logo-white.f568efd4.png";